var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.175 5.86255C2.3625 5.67505 2.5845 5.5813 2.841 5.5813C3.097 5.5813 3.31875 5.67505 3.50625 5.86255L9 11.3563L14.5125 5.8438C14.6875 5.6688 14.9062 5.5813 15.1687 5.5813C15.4312 5.5813 15.6562 5.67505 15.8437 5.86255C16.0312 6.05005 16.125 6.27205 16.125 6.52855C16.125 6.78455 16.0312 7.0063 15.8437 7.1938L9.525 13.4938C9.45 13.5688 9.36875 13.622 9.28125 13.6535C9.19375 13.6845 9.1 13.7 9 13.7C8.9 13.7 8.80625 13.6845 8.71875 13.6535C8.63125 13.622 8.55 13.5688 8.475 13.4938L2.15625 7.17505C1.98125 7.00005 1.89375 6.78455 1.89375 6.52855C1.89375 6.27205 1.9875 6.05005 2.175 5.86255Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.2ed5906f0fa57b0a428380567f2167e6.svg";
export { ForwardRef as ReactComponent };